import React, { memo, useEffect, useState } from "react";
import { motion } from "framer-motion";
import { createCustomer, createUser } from "../api/CustomerApi";
import { getAllRole } from "../api/RoleApi";
import { CustomerAutoSearch } from "../api/CustomerApi";
import tw from "twin.macro";
import { currentRegister } from "../utility/Constant";
import toast from "react-hot-toast";
import { getBranchId } from "utility/HeaderConfig";
import logo189 from "../images/AboutUs/image1re.jpg";
import Divider from "../images/MyScheme/divider.png";
import { useCartContext } from "context/UseCartContext";
import SEO from "./headers/Seo";

import what from "../images/assets/what.webp"
import { Link } from "react-router-dom";
import { Heading } from "lucide-react";
import Modal from "react-bootstrap/Modal";
const InputContainer = tw.div`my-5`;

function RegisterModal(props) {
  const [name, setName] = useState("");
  const [mobileno, setmobileno] = useState("");
  const [email, setemail] = useState("");
  const [address, setaddress] = useState("");
  const [password, setpassword] = useState("");
  const [rememberMe, setRememberMe] = useState(false);
  const [remember, setRemember] = useState(false);
  const [invalidEmail, setinvalidEmail] = useState("");
  const [invalidMobile, setInvalidMobile] = useState("");

  const [emptyField, setEmptyField] = useState(false);
  const [availableEmail, setAvailableEmail] = useState(false);

  const [roleId, setRoleId] = useState(false);

  const [Loading, setLoading] = useState(false);
  const [availableMobile, setAvailableMobile] = useState(false);

  const { dispatch } = useCartContext();

  useEffect(() => {
    getRoleList();
  }, []);


  const getRoleList = () => {
    const filterData = {
      name: "Customer",
    };
    getAllRole(filterData).then((data) => {
      if (data.response.length > 0) {
        setRoleId(data.response[0].id);
      }
    });
  };

  const submitForm = (e) => {
    e.preventDefault();
    postAjaxRequest();
  };

  const postAjaxRequest = () => {
    //eslint-disable-next-line
    const reg = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
    const mobileReg = /^(\+\d{1,3}[- ]?)?\d{10}$/;

    //Invalid message validate //
    if (!reg.test(email) && email !== "") {
      setinvalidEmail(true);
      toast.error(" Invalid Email", {
        duration: 3000,
        position: "top-right",
      });
    } else {
      setinvalidEmail(false);
    }
    if (!mobileReg.test(mobileno) && mobileno !== "") {
      setInvalidMobile(true);
      setAvailableMobile(false);
    } else {
      setInvalidMobile(false);
    }

    // Empty Validate Field //
    const validateField = () => {
      if (name && password && reg.test(email) && mobileReg.test(mobileno) && address) {
        return true;
      } else {
        setEmptyField(true);
        setAvailableMobile(false);
        return false;
      }
    };

    if (validateField()) {
      const customerSearch = `mobile=${mobileno}&beforeCreatedAt=${currentRegister()}`;
      const response = CustomerAutoSearch(customerSearch);
      response.then(
        (data) => {
          if (data.response.length > 0) {
            setAvailableMobile(true);
            toast.error("Customer already available in this mobile number", {
              duration: 3000,
              position: "top-right",
            });
          } else {
            setAvailableMobile(false);
            createUserAccount();
          }
        },
        (err) => {
          console.log(err);
        }
      );
    }
  };

  const createUserAccount = () => {
    setLoading(true);
    const userDetils = {
      username: mobileno,
      password: password,
      rolesList: [roleId],
      email: email !== "" ? email : null,
      branch: getBranchId(),
      employeeId: null

    };
    const responseData = createUser(JSON.stringify(userDetils));
    responseData.then(
      (data) => {
        createCustomerFunc();
      },
      (err) => {
        if (err.response) {
          let message = err.response.data.displayMessage;
          toast.error(message, {
            position: "top-right",
            duration: 2000
          })
          const index = message.split(" ");
          if (index[0] === "User") {
            setAvailableMobile(true);
          } else {
            setAvailableEmail(true);
          }
        }
        setLoading(false);
      }
    );
  };

  const createCustomerFunc = () => {
    setLoading(false);
    const customerDetails = {
      branchId: getBranchId(),
      name: name,
      mobile: mobileno,
      email: email,
      customerType: "CUSTOMER",
      enrollmentDate: currentRegister(),
      crmStatus: "ENGAGING",
      enquirySource: "WEB",
      religion: "NA",
      customerAddress: {
        address1: address,
      },
    };
    const responseData = createCustomer(JSON.stringify(customerDetails));
    responseData.then(
      (data) => {
        setLoading(false);
        setAvailableEmail(false);
        setAvailableMobile(false);
        toast.success("Customer And User Account Created Successfully...!", {
          duration: 3000,
          position: "top-right",
        });
        setTimeout(() => {
          dispatch({ type: "MODAL", payload: "login" });
        }, 1000);
      },
      (err) => {
        console.log(err);
        setAvailableEmail(false);
      }
    );
  };

  const close = () => {
    dispatch({ type: "MODAL", payload: false });
  };

  return (
    <Modal
      show={true}
      animation={false}
      transition={null}
      style={{ overlay: { zIndex: 1000 } }}
      centered
    >
      <SEO
        title='User Details - Jai Maruthi Jewellery'
        description='Beginner friendly page for learning React Helmet.'
        name='Company name.'
        type='article' />
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        tw="overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none"
      >
        <div
          tw="shadow-lg relative fixed flex bg-white outline-none focus:outline-none rounded-lg"
          className="col-11 col-sm-11 col-md-10 col-lg-8 col-xl-7  m-sm-0 "
          style={{
            top: "50%",
            left: "50%",
            transform: "translate(-50%,-50%)",
          }}
        >
          <div className="d-none d-md-block col-sm-5 text-center position-relative mt-5"  >
            {/* <h6 style={{ color: " #014c52", fontSize: "18px", fontFamily: "lato, sans-serif", }}>SIGN UP</h6> */}

            <img src={logo189} className="w-75 h-100" style={{ aspectRatio: "1 / 1", objectFit: "cover", borderRadius: "10px", marginTop: "-20px", marginRight: "30px" }} alt="signup" />
          </div>
          <div className="col-12 col-md-7 ">
            <div className="col-lg-10">
              <form>

                <div tw="my-5">
                  <div tw="relative">
                    <input
                      type="text"
                      id="name"
                      value={name}
                      onChange={(e) => {
                        setName(e.target.value);
                      }}
                      tw="focus:outline-none focus:border-custom-100 focus:ring-1 bg-gray-200 border border-gray-300 text-gray-900 text-sm rounded-lg block w-full pl-10 pr-10 py-4"
                      placeholder="Enter Your Name"
                      className={`${emptyField && name === "" ? "border border-danger" : ""}`}
                    />
                    <div tw="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
                      <i className="bi bi-person" tw="text-xl"></i>
                    </div>
                    {emptyField && name === "" ? (
                      <div tw="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none">
                        <i className="bi bi-exclamation-circle text-danger"></i>
                      </div>
                    ) : (
                      ""
                    )}
                  </div>
                  {emptyField && name === "" ? (
                    <p tw="text-red-500 mt-1 mb-0 mx-5">
                      Enter Your Username
                    </p>
                  ) : (
                    " "
                  )}
                </div>
                <div tw="my-5">
                  <div tw="relative">
                    <div tw="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
                      <i className="bi bi-phone" tw="text-xl"></i>
                    </div>
                    <input
                      type="text"
                      id="mobile"
                      value={mobileno}
                      onChange={(e) => {
                        setmobileno(e.target.value);
                      }}
                      tw="focus:outline-none focus:border-custom-100
                              focus:ring-1   bg-gray-200 border border-gray-300 
                              text-gray-900 text-sm rounded-lg  block w-full px-10 py-4"
                      placeholder="Enter Your Mobile Number "
                      className={`${(emptyField && mobileno === "") ||
                        invalidMobile ||
                        availableMobile
                        ? "border border-danger"
                        : ""
                        }`}
                    />
                    {(emptyField && mobileno === "") ||
                      invalidMobile ||
                      availableMobile ? (
                      <div tw="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none">
                        <i className="bi bi-exclamation-circle text-danger"></i>
                      </div>
                    ) : (
                      ""
                    )}
                  </div>
                  {availableMobile && (
                    <p tw="text-red-500 mt-1 mb-0 mx-5">
                      Mobile No is Already Available. Please SignUp With
                      Another Mobile Number
                    </p>
                  )}
                  {invalidMobile && mobileno !== "" && (
                    <p tw="text-red-500 mt-1 mb-0 mx-5">
                      Mobile Number Field is Invalid
                    </p>
                  )}
                  {emptyField && mobileno === "" && (
                    <p tw="text-red-500 mt-1 mb-0 mx-5">
                      Enter Your Mobile Number
                    </p>
                  )}
                </div>
                <div tw="my-5">
                  <div tw="relative">
                    <div tw="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
                      <i className="bi bi-envelope" tw="text-xl"></i>
                    </div>
                    <input
                      type="email"
                      id="e-mail"
                      value={email}
                      onChange={(e) => {
                        setemail(e.target.value);
                      }}
                      tw="focus:outline-none focus:border-custom-100
                              focus:ring-1   bg-gray-200 border border-gray-300 
                              text-gray-900 text-sm rounded-lg  block w-full px-10 py-4"
                      placeholder="Enter Your Email"
                      className={`${(emptyField && email === "") || invalidEmail
                        ? "border border-danger"
                        : ""
                        }`}
                    />
                    {emptyField && email === "" ? (
                      <div tw="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none">
                        <i className="bi bi-exclamation-circle text-danger"></i>
                      </div>
                    ) : (
                      ""
                    )}
                  </div>
                  {availableEmail ? (
                    <p tw="text-red-500 mt-1 mb-0 mx-5">
                      Email is Already Available. Please SignUp With Another
                      Email Id
                    </p>
                  ) : (
                    " "
                  )}
                  {invalidEmail && email !== "" ? (
                    <p tw="text-red-500 mt-1 mb-0 mx-5">
                      Email Field is Invalid
                    </p>
                  ) : (
                    ""
                  )}

                  {emptyField && email === "" ? (
                    <p tw="text-red-500 mt-1 mb-0 mx-5">Enter Your Email</p>
                  ) : (
                    " "
                  )}
                </div>
                <div tw="my-5">
                  <div tw="relative">
                    <div tw="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
                      <i className="bi bi-file-lock2" tw="text-xl"></i>
                    </div>
                    {emptyField && password === "" ? (
                      <div tw="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none">
                        <i className="bi bi-exclamation-circle text-danger"></i>
                      </div>
                    ) : (
                      ""
                    )}
                    <input
                      type="password"
                      id="password"
                      tw="focus:outline-none focus:border-custom-100
                      focus:ring-1   bg-gray-200 border border-gray-300 
                      text-gray-900 text-sm rounded-lg  block w-full px-10 py-4"
                      placeholder="Enter Your password"
                      onChange={(e) => {
                        setpassword(e.target.value);
                      }}
                      className={`${emptyField && password === ""
                        ? "border border-danger"
                        : ""
                        }`}
                    />
                  </div>
                  {emptyField && password === "" ? (
                    <p tw="text-red-500 mt-1 mx-5 mb-0">
                      Enter Your password
                    </p>
                  ) : (
                    " "
                  )}
                </div>
                <div tw="my-5">
                  <div tw="relative">
                    <div tw="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
                      <i className="bi bi-geo-alt" tw="text-xl"></i>
                    </div>
                    <input
                      type="text"
                      id="address"
                      value={address}
                      onChange={(e) => {
                        setaddress(e.target.value);
                      }}
                      tw="focus:outline-none focus:border-custom-100
                              focus:ring-1   bg-gray-200 border border-gray-300 
                              text-gray-900 text-sm rounded-lg  block w-full px-10 py-4"
                      placeholder="Enter Your Address"
                      className={`${emptyField && address === ""
                        ? "border border-danger"
                        : ""
                        }`}
                    />
                    {emptyField && address === "" ? (
                      <div tw="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none">
                        <i className="bi bi-exclamation-circle text-danger"></i>
                      </div>
                    ) : (
                      ""
                    )}
                  </div>
                  {emptyField && address === "" ? (
                    <p tw="text-red-500 mt-1 mb-0 mx-5">Enter Your Address</p>
                  ) : (
                    " "
                  )}
                </div>
                <button
                  type="submit"
                  tw=" transition w-full text-white active:bg-custom-100 focus:outline-none rounded-lg text-sm p-5 text-center uppercase"
                  onClick={submitForm}
                  disabled={Loading ? true : ""}
                  className={`${Loading ? "bg-secondary" : ""} hoverEffect`}
                >
                  {Loading ? (
                    <>
                      <span
                        className="spinner-border spinner-border-sm"
                        role="status"
                        aria-hidden="true"
                      ></span>
                      <span className="mx-2">Loading . . .</span>
                    </>
                  ) : (
                    <>
                      <i
                        className="bi bi-box-arrow-in-right"
                        tw="mr-3 px-2 text-base"
                      ></i>
                      Sign Up
                    </>
                  )}
                </button>
                <div className="mb-3" tw="pt-5 text-center">
                  Already Have account ?
                  <span onClick={() => dispatch({ type: "MODAL", payload: 'login' })}>
                    <span className="" tw="text-[#daab20] hover:text-[#30c5d6] mx-2 text-sm tracking-wider font-bold cursor-pointer ">
                      Login here
                    </span>
                  </span>
                </div>
              </form>
            </div>
          </div>
          <div className="position-absolute top-0 end-0" onClick={close}>
            <i
              className="bi bi-x m-2"
              tw="text-3xl text-gray-600 cursor-pointer hover:text-custom-100"
            ></i>
          </div>
        </div>
      </motion.div>
    </Modal>
  );
}

export default memo(RegisterModal);
